<template>
  <div class="section-control section-control-pic">
        <!-- 放大缩小部分
    --><div class="section-zoom-area">
            <span
class="zoom-out cp"
@click="zoomOut"
>
                <svg class="item-icon">
                    <use xlink:href="#zoomOut" />
                </svg>
            </span><!--
        --><span class="zoom-num">{{ zoomNum }}</span><!--
        --><span
class="zoom-in cp"
@click="zoomIn"
>
                <svg class="item-icon">
                    <use xlink:href="#zoomIn" />
                </svg>
            </span>
    </div><!--旋转部分
    --><div class="section-rotate-pic">
            <span
class="rotate-ccw cp"
@click="pageRotateCcw"
>
                <svg class="item-icon">
                    <use xlink:href="#leftRotation" />
                </svg>
            </span><!--
        --><span
class="rotate-cw cp"
@click="pageRotateCw"
>
                <svg class="item-icon">
                    <use xlink:href="#rightRotation" />
                </svg>
            </span>
    </div><!--原图
    --><span
:class="['section-original-pic','cp', onlyHasOriginal ? 'section-original-pic-disable':'']"
@click="getOriginalPic"
>
            <co-tips
v-if="onlyHasOriginal"
:content="this.$t('目前已是原图')"
placement="top"
>
                <span class="pic-text">{{ picType }}</span>
            </co-tips>
            <span
v-else
class="pic-text"
>{{ picType }}</span>
    </span><!-- 全屏
    --><span
v-if="!isIE"
class="section-fullScreen cp"
@click="presentationMode"
>
            <svg class="item-icon">
                <use :xlink:href="displayFullScreen ? '#iconFullRecovery':'#iconFullScreen'" />
            </svg>
        </span>
  </div>
</template>
<script>
import coTips from 'components/common/tips/index.vue'
import { isIE, requestFullScreen, exitFullscreen } from 'js/util/util'

export default {
  components: {
    coTips,
  },
  data() {
    return {
      displaySidebar: false, // 展开左侧栏
      isOriginalType: false, // 当前是原图
      displayFullScreen: false,
    }
  },
  computed: {
    /**
             * 是否为ie
             */
    isIE() {
      return isIE()
    },
    /**
             * 当前是不是只有原图形式
             */
    onlyHasOriginal() {
      return this.checkPicObj('isOriginal')
    },
    /**
             * 监听图片组件的变化，更新图片类型标识
             */
    picType() {
      const isOriginal = this.checkPicObj('type')
      if (isOriginal) return this.$t('标准')
      return this.$t('原图')
    },
    /**
             * 监听图片组件的变化，来更新zoom数
             */
    zoomNum() {
      const zoom = this.checkPicObj('zoom')
      if (typeof zoom === 'number') {
        return `${zoom}%`
      }
      return '0%'
    },
  },
  mounted() {
    window.addEventListener('resize', this.pushEsc)
  },
  methods: {
    /**
             * 放大
             */
    zoomIn() {
      // this.zoomNum = document.getElementsByClassName('pic-box')[0].querySelectorAll('#zoomLevel')[0].innerHTML;
      this.getPicBox().querySelectorAll('#zoomIn')[0].click()
    },
    /**
             * 缩小
             */
    zoomOut() {
      // this.zoomNum = document.getElementsByClassName('pic-box')[0].querySelectorAll('#zoomLevel')[0].innerHTML;
      this.getPicBox().querySelectorAll('#zoomOut')[0].click()
    },
    /**
             * 顺时针旋转
             */
    pageRotateCw() {
      this.getPicBox().querySelectorAll('#pageRotateCw')[0].click()
    },
    /**
             * 逆时针旋转
             *
             */
    pageRotateCcw() {
      this.getPicBox().querySelectorAll('#pageRotateCcw')[0].click()
    },
    /**
             * 原图
             */
    getOriginalPic() {
      this.getPicBox().querySelectorAll('#srcType')[0].click()
    },
    /**
             * 全屏
             */
    presentationMode() {
      const me = this
      !me.displayFullScreen ? requestFullScreen() : exitFullscreen()
      me.getPicBox().querySelectorAll('#presentationMode')[0].click() // 调用pic.vue里面的全屏方法
      me.$nextTick(() => {
        me.displayFullScreen = !me.displayFullScreen
        me.$emit('presentationMode', me.displayFullScreen)
      })
    },
    /**
             * 检查预览对象是否有值
             */
    checkPicObj(attr) {
      const obj = this.$store.state.previewInfo
      if (obj) {
        return obj[attr]
      }
      return ''
    },
    /**
             * 获取pic所在container的dom对象
             */
    getPicBox() {
      const picBox = document.getElementsByClassName('pic-box')[0]
      if (picBox) {
        return picBox
      }
    },
    /**
             * 校验是否为全屏
             */
    checkFull() {
      // console.log(document.fullscreenEnabled,"=========", window.fullScreen,"=========", document.webkitIsFullScreen,"=========", document.msFullscreenEnabled)
      // var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // if (isFull === undefined) isFull = false
      // return isFull
      return document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
    },
    /**
             * 按esc键退出全屏
             */
    pushEsc() {
      if (!this.checkFull()) {
        if (this.displayFullScreen) {
          this.displayFullScreen = !this.displayFullScreen
          this.getPicBox().querySelectorAll('#presentationMode')[0].click()
        }
      }
    },
  },
}
</script>
<style lang="less">
</style>
